/**
 * Ranking 页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const rankingCommonConfig = {
  texts: {
    noMore: 'No more ~',
    loading: 'Loading...',
  },
}
